var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#F4E8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_429_244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8289 16.4487H7.23242C7.27005 15.0756 7.56629 13.773 8.12117 12.541C8.67606 11.309 9.41433 10.2416 10.336 9.33869C11.2577 8.43583 12.3345 7.72577 13.5665 7.20851C14.7985 6.69125 16.1199 6.43262 17.5306 6.43262C18.9225 6.43262 20.2392 6.69125 21.4807 7.20851C22.7221 7.72577 23.8036 8.43583 24.7253 9.33869C25.647 10.2416 26.3852 11.309 26.9402 12.541C27.495 13.773 27.7912 15.0756 27.8289 16.4487Z",
    fill: "#A53FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.718 17.8345H13.5098V21.0427H16.718V17.8345Z",
    fill: "#A53FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.942 18.2925H9.65039V20.5841H11.942V18.2925Z",
    fill: "#D29FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4834 23.3354H10.1113V24.7075H11.4834V23.3354Z",
    fill: "#D29FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2584 22.876H13.9668V25.1676H16.2584V22.876Z",
    fill: "#A53FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0338 22.876H18.7422V25.1676H21.0338V22.876Z",
    fill: "#D29FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08589 18.751H6.71094V20.1259H8.08589V18.751Z",
    fill: "#D29FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8007 26.6484H14.4258V28.0234H15.8007V26.6484Z",
    fill: "#A53FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5742 26.6484H19.1992V28.0234H20.5742V26.6484Z",
    fill: "#D29FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.289 18.751H26.9141V20.1259H28.289V18.751Z",
    fill: "#D29FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3482 18.2925H23.0566V20.5841H25.3482V18.2925Z",
    fill: "#A53FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8896 23.3354H23.5176V24.7075H24.8896V23.3354Z",
    fill: "#A53FF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4914 17.8345H18.2832V21.0427H21.4914V17.8345Z",
    fill: "#D29FFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_429_244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 22.2069,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectTable);
export default __webpack_public_path__ + "static/media/select-table.a98711dc8caabc0e5cd5db83bf3fc681.svg";
export { ForwardRef as ReactComponent };